/* eslint-disable import/group-exports */
import { IScreenDimensions } from "./sizes";

export const H1_SIZE_MOBILE = 32;
export const H1_SIZE_TABLET = 38;
export const H1_SIZE_DESKTOP = 48;

export const H1_LINE_HEIGHT_MOBILE = 36;
export const H1_LINE_HEIGHT_TABLET = 44;
export const H1_LINE_HEIGHT_DESKTOP = 52;

export const H2_SIZE_MOBILE = 29;
export const H2_SIZE_TABLET = 33;
export const H2_SIZE_DESKTOP = 40;

export const H2_LINE_HEIGHT_MOBILE = 32;
export const H2_LINE_HEIGHT_TABLET = 36;
export const H2_LINE_HEIGHT_DESKTOP = 44;

export const H3_SIZE_MOBILE = 26;
export const H3_SIZE_TABLET = 28;
export const H3_SIZE_DESKTOP = 33;

export const H3_LINE_HEIGHT_MOBILE = 32;
export const H3_LINE_HEIGHT_TABLET = 32;
export const H3_LINE_HEIGHT_DESKTOP = 46;

export const H4_SIZE_MOBILE = 23;
export const H4_SIZE_TABLET = 24;
export const H4_SIZE_DESKTOP = 28;

export const H4_LINE_HEIGHT_MOBILE = 24;
export const H4_LINE_HEIGHT_TABLET = 28;
export const H4_LINE_HEIGHT_DESKTOP = 32;

export const H5_SIZE_MOBILE = 20;
export const H5_SIZE_TABLET = 21;
export const H5_SIZE_DESKTOP = 23;

export const H5_LINE_HEIGHT_MOBILE = 24;
export const H5_LINE_HEIGHT_TABLET = 24;
export const H5_LINE_HEIGHT_DESKTOP = 24;

export const H6_SIZE_MOBILE = 18;
export const H6_SIZE_TABLET = 18;
export const H6_SIZE_DESKTOP = 19;

export const H6_LINE_HEIGHT_MOBILE = 20;
export const H6_LINE_HEIGHT_TABLET = 20;
export const H6_LINE_HEIGHT_DESKTOP = 20;

export const P_LARGE_SIZE_MOBILE = 18;
export const P_LARGE_SIZE_TABLET = 19;
export const P_LARGE_SIZE_DESKTOP = 21;

export const P_LARGE_LINE_HEIGHT_MOBILE = 28;
export const P_LARGE_LINE_HEIGHT_TABLET = 32;
export const P_LARGE_LINE_HEIGHT_DESKTOP = 36;

export const P_SIZE = 16;
export const P_LINE_HEIGHT = 24;

export const P_SMALL_SIZE = 13;
export const P_SMALL_LINE_HEIGHT = 20;

export const P_EXTRA_SMALL_SIZE = 11;
export const P_EXTRA_SMALL_LINE_HEIGHT = 16;

export const P_TINY_SIZE = 9;
export const P_TINY_LINE_HEIGHT = 12;

export const P_SIZES = Object.freeze({
  default: P_SIZE,
  small: P_SMALL_SIZE,
  extra_small: P_EXTRA_SMALL_SIZE,
  tiny: P_TINY_SIZE,
  large: P_LARGE_SIZE_MOBILE,
});

export const P_LINE_HEIGHTS = Object.freeze({
  default: P_LINE_HEIGHT,
  small: P_SMALL_LINE_HEIGHT,
  extra_small: P_EXTRA_SMALL_LINE_HEIGHT,
  tiny: P_TINY_LINE_HEIGHT,
  large: P_LARGE_LINE_HEIGHT_MOBILE,
});

export interface IFontSizes {
  default: number;
  small: number;
  extra_small: number;
  tiny: number;
  large: number | IScreenDimensions;
}

export const H1_DIMENSIONS: IScreenDimensions = Object.freeze({
  mobile: H1_SIZE_MOBILE,
  tablet: H1_SIZE_TABLET,
  desktop: H1_SIZE_DESKTOP,
});

export const H1_LINE_HEIGHTS: IScreenDimensions = Object.freeze({
  mobile: H1_LINE_HEIGHT_MOBILE,
  tablet: H1_LINE_HEIGHT_TABLET,
  desktop: H1_LINE_HEIGHT_DESKTOP,
});

export const H2_DIMENSIONS: IScreenDimensions = Object.freeze({
  mobile: H2_SIZE_MOBILE,
  tablet: H2_SIZE_TABLET,
  desktop: H2_SIZE_DESKTOP,
});

export const H2_LINE_HEIGHTS: IScreenDimensions = Object.freeze({
  mobile: H2_LINE_HEIGHT_MOBILE,
  tablet: H2_LINE_HEIGHT_TABLET,
  desktop: H2_LINE_HEIGHT_DESKTOP,
});

export const H3_DIMENSIONS: IScreenDimensions = Object.freeze({
  mobile: H3_SIZE_MOBILE,
  tablet: H3_SIZE_TABLET,
  desktop: H3_SIZE_DESKTOP,
});

export const H3_LINE_HEIGHTS: IScreenDimensions = Object.freeze({
  mobile: H3_LINE_HEIGHT_MOBILE,
  tablet: H3_LINE_HEIGHT_TABLET,
  desktop: H3_LINE_HEIGHT_DESKTOP,
});

export const H4_DIMENSIONS: IScreenDimensions = Object.freeze({
  mobile: H4_SIZE_MOBILE,
  tablet: H4_SIZE_TABLET,
  desktop: H4_SIZE_DESKTOP,
});

export const H4_LINE_HEIGHTS: IScreenDimensions = Object.freeze({
  mobile: H4_LINE_HEIGHT_MOBILE,
  tablet: H4_LINE_HEIGHT_TABLET,
  desktop: H4_LINE_HEIGHT_DESKTOP,
});

export const H5_DIMENSIONS: IScreenDimensions = Object.freeze({
  mobile: H5_SIZE_MOBILE,
  tablet: H5_SIZE_TABLET,
  desktop: H5_SIZE_DESKTOP,
});

export const H5_LINE_HEIGHTS: IScreenDimensions = Object.freeze({
  mobile: H5_LINE_HEIGHT_MOBILE,
  tablet: H5_LINE_HEIGHT_TABLET,
  desktop: H5_LINE_HEIGHT_DESKTOP,
});

export const H6_DIMENSIONS: IScreenDimensions = Object.freeze({
  mobile: H6_SIZE_MOBILE,
  tablet: H6_SIZE_TABLET,
  desktop: H6_SIZE_DESKTOP,
});

export const H6_LINE_HEIGHTS: IScreenDimensions = Object.freeze({
  mobile: H6_LINE_HEIGHT_MOBILE,
  tablet: H6_LINE_HEIGHT_TABLET,
  desktop: H6_LINE_HEIGHT_DESKTOP,
});

export const P_LARGE_DIMENSIONS: IScreenDimensions = Object.freeze({
  mobile: P_LARGE_SIZE_MOBILE,
  tablet: P_LARGE_SIZE_TABLET,
  desktop: P_LARGE_SIZE_DESKTOP,
});

export const P_LARGE_LINE_HEIGHTS: IScreenDimensions = Object.freeze({
  mobile: P_LARGE_LINE_HEIGHT_MOBILE,
  tablet: P_LARGE_LINE_HEIGHT_TABLET,
  desktop: P_LARGE_LINE_HEIGHT_DESKTOP,
});

export type IFontWeightName = "heavy" | "bold" | "medium" | "regular" | "light";
